jQuery(document).ready(function ($) {
    var $depoimentos = $('.home-depoimentos .swiper');

    if (!$depoimentos.length) return

    var mySwiper = new Swiper('.home-depoimentos .swiper', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        navigation: {
            nextEl: $depoimentos.parent().find(".carousel-navigation .next")[0],
            prevEl: $depoimentos.parent().find(".carousel-navigation .prev")[0],
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            },
        }
    });
});